// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"479":"c661e52f","688":"b6151b6d"}[chunkId] + ".chunk.css";
};